<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">

  <div class="p-col-12  p-col-align-start ">

    <div class="box text-center shadow-lg px-5 py-5 mb-2 bg-white rounded basetext">
      <!-- INSTRUÇÃO  parametrizado carregando os dados da base-->

      <div class="text-left text-info ">
        <h4>CANDIDATURA</h4>
      </div>
      <div class="text-justify mb-3">
        <p>{{instrucao}}</p>
      </div>
       <!-- FIM-INSTRUÇÃO -->

      <!--pTooltip="Aceitar termos de condições"-->
      <div>
        <button type="button" class="btn btn-info btn-block btn-lg"
          (click)="getTermoAceitoAvancar()">
          CONFIRMA
          <i class="far fa-check-circle"></i>
        </button>
      </div>
    </div>

  </div>
</div>
